// extracted by mini-css-extract-plugin
export var bubble = "_2a-0";
export var container = "_2a-f";
export var contrastBorder = "_2a-g";
export var greyOut = "_2a-2";
export var initialsColor0 = "_2a-3";
export var initialsColor1 = "_2a-4";
export var initialsColor10 = "_2a-d";
export var initialsColor11 = "_2a-e";
export var initialsColor2 = "_2a-5";
export var initialsColor3 = "_2a-6";
export var initialsColor4 = "_2a-7";
export var initialsColor5 = "_2a-8";
export var initialsColor6 = "_2a-9";
export var initialsColor7 = "_2a-a";
export var initialsColor8 = "_2a-b";
export var initialsColor9 = "_2a-c";
export var initialsWrapper = "_2a-1";
export var large = "_2a-l";
export var medium = "_2a-k";
export var mediumSmall = "_2a-j";
export var mediumSmallMedium = "_2a-o";
export var micro = "_2a-h";
export var small = "_2a-i";
export var tiny = "_2a-n";
export var xTiny = "_2a-m";